export default (function () {
  return {
    logImpression: false,
    text: 'Learn More'
  };
});